import { useCallback, useEffect, useState } from "react";
import { PopService } from "../services/PopService";

export const useHookPopDetail = ({ id }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const getData = useCallback(async () => {
        setLoading(true);
        setError(null);
        try{
            const res = await PopService.show({ id });
            setData(res.data.data);
        }catch(err){
            setError(err);
            throw err;
        }finally{
            setLoading(false);
        }
    }, [id]);

    useEffect(()=>{
        getData();
    },[getData]);

    return {
        data,
        loading,
        error,
        
        refreshData: () => getData(),
    }
}